import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./Popular_Experts.css";
import Common_Expert_Card from "../../../common_components/common-expert-card/Common_Expert_Card";
import Common_Headings from "../../../common_components/common_heading/Common_Headings";
import { getVendorExpert } from "../../../../features/admin/vendor_expert/Slice";

function Popular_Experts({ selectedProfessionIds, professions, searchName }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const plans =
    useSelector((state) => state?.vendor_expert?.vendorexperts?.expertPlans) ||
    [];

  useEffect(() => {
    if (selectedProfessionIds?.length) {
      dispatch(
        getVendorExpert({
          type: "expert",
          profession_id: selectedProfessionIds,
          search_name: searchName,
        }),
      );
    }
  }, [selectedProfessionIds, searchName, dispatch]);

  if (!selectedProfessionIds?.length) return null;

  return (
    <>
      {plans.length ? (
        plans.map((expert) => (
          <div className="mt-4 vendor-section">
            <Common_Headings
              title={expert?.name}
              onSeeAll={() =>
                navigate(
                  `/experts?type=expert&profession_id[0]=${expert.id}&see_all_status=1`,
                )
              }
            />

            <div className="row">
              {expert?.experts?.length ? (
                expert?.experts?.map((expert) => (
                  <div
                    key={expert.id}
                    className="col-12 col-sm-6 col-md-6 col-xl-4 mb-4"
                  >
                    <Common_Expert_Card expert={expert} />
                  </div>
                ))
              ) : (
                <p className="text-muted">No experts found</p>
              )}
            </div>
          </div>
        ))
      ) : (
        <p className="text-muted">No experts found</p>
      )}
    </>
  );
}

export default Popular_Experts;
